const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

export const getLogoUrl = (empresaId, tipo = "principal") =>
  `${API_BASE}/api/empresas/${empresaId}/logo/${tipo}`;

export const getEmpresaId = () =>
  Number(localStorage.getItem("empresaId") || 0);
